import { render, staticRenderFns } from "./notice-content.vue?vue&type=template&id=47ba0130&scoped=true&"
import script from "./notice-content.vue?vue&type=script&lang=js&"
export * from "./notice-content.vue?vue&type=script&lang=js&"
import style0 from "./notice-content.vue?vue&type=style&index=0&id=47ba0130&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba0130",
  null
  
)

export default component.exports